import { connect } from 'react-redux';
import React, { Component } from 'react';
import { renderKBInput, renderKBMorePhotoUpload, renderKBSelect, renderKBTextarea, renderKBUserInput, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';

import { bindActionCreators } from 'redux';
import * as valid from 'utils/validate';
import { api,
apiUtils } from 'app/services';
import {
KBInput,
KBFormError,
KBButton,
KBPopover } from
'components';
import { SHOP_STATUS } from 'app/constants';
import { salesProductsActions, successState } from 'app/actions';
import * as selectors from 'app/selectors';
import * as constants from 'app/constants';
import { showApiError } from 'utils/feedback';

var SalesProductsForm = class extends React.Component {constructor(props) {super(props);this.createSalesProducts = this.createSalesProducts.bind(this);}createSalesProducts(
  model) {
    const {
      createSalesProductsActions,
      updateSalesProductsActions,
      product,
      state,
      successAction,
      shopping_id } =
    this.props;

    if (state) {
      return api.putSalesProducts(product.id, model).then(json => {
        updateSalesProductsActions.success(json);
        successAction({ message: '修改商品成功!' });
        KBPopover.close();
        return true;
      }).catch(error => {
      showApiError(error);
    });
    }

    model.shop_id = shopping_id;
    return api.postSalesProducts(model).then(json => {
      createSalesProductsActions.success(json);
      successAction({ message: '创建商品成功!' });
      KBPopover.close();
      return true;
    }).catch(error => {
      showApiError(error);
    });
  }render()

  {
    const {
      fields: {
        product_category_id,
        title,
        images,
        unit_price,
        barcode,
        sku,
        cost,
        point,
        description,
        number,
        status },

      error,
      submitting,
      handleSubmit,
      virtual_currency_name } =
    this.props;
    const { locations, state, productCategories, product } = this.props;
    let product_category = product ?
    [product.product_category] :
    productCategories;

    const oneClass = {
      className: 'kb-form-group kb-form-210 kb-form-alone' };

    return (
      <form onSubmit={handleSubmit(this.createSalesProducts)}>
        <header className="kb-form-header">
          <h2 className="header-title">{state ? '修改商品' : '创建商品'}</h2>
          <i
          className="iconfont header-close icon-cancel"
          onClick={KBPopover.close} />

        </header>
        <div className="kb-form-container">
          <div className="kb-row">
            <Field name="title" component={renderKBInput}
            className="kb-form-group kb-form-210 kb-form-alone"
            isRequired={true}

            title="商品名称"
            fistFoucs={true} />

          </div>
          <div className="kb-row">
            <Field name="product_category_id" component={renderKBUserInput}
            title="商品分类"
            placeholder={'商品分类'}
            {...oneClass}
            isRequired={true}

            multi={false}
            users={productCategories}
            selectedUsers={product_category} />

          </div>
          <div className="kb-row">
            <Field name="description" component={renderKBTextarea}
            title="详情介绍"
            placeholder="详情介绍"
            className="kb-form-group kb-form-210 kb-form-alone"

            value={description.value} />

          </div>
          <div className="kb-row">
            <Field name="cost" component={renderKBInput}
            className="kb-form-group kb-form-210 kb-form-alone"

            title="进价" />

          </div>
          <div className="kb-row">
            <Field name="unit_price" component={renderKBInput}
            className="kb-form-group kb-form-210 kb-form-alone"
            isRequired={true}

            title="售价" />

          </div>
          <div className="kb-row">
            <Field name="point" component={renderKBInput}
            className="kb-form-group kb-form-210 kb-form-alone"
            label="true"
            isRequired={true}

            title={`${virtual_currency_name}价`} />

          </div>
          <div className="kb-row">
            <Field name="number" component={renderKBInput}
            className="kb-form-group kb-form-210 kb-form-alone"

            title="商品库存"
            isRequired={true} />

          </div>
          <div className="kb-row">
            <Field name="status" component={renderKBSelect}
            className="kb-form-group kb-div-210 kb-form-alone"
            title="商品状态"

            arrayData={SHOP_STATUS} />

          </div>
          <div className="kb-row">
            <Field name="sku" component={renderKBInput}
            className="kb-form-group kb-form-210 kb-form-alone"

            title="商品编号" />

          </div>
          <div className="kb-row">
            <Field name="barcode" component={renderKBInput}
            className="kb-form-group kb-form-210 kb-form-alone"

            title="条形码" />

          </div>
          <div className="kb-row">
            <Field name="images" component={renderKBMorePhotoUpload}
            title="上传图片"
            hint="允许多张上传,格式为png或jpg,大小不大于20M"
            photoShow={true}
            className="kb-form-group kb-form-210 kb-form-alone"

            text="上传商品图片"
            prefix="images/shopping/salesproduct/"
            accept="image/*" />

          </div>
          <div className="kb-row fixed-form-btn">
            <span className="cancel-btn" onClick={KBPopover.close}>
              取消
            </span>
            <KBButton className="certain-btn" submitting={submitting}>
              确定
            </KBButton>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  const { section } = props;
  const productCategories = selectors.getProductCategories(
  state,
  props.shopping_id);

  let virtual_currency_name = selectors.getSpaceVirtualCurrencyName(state);

  return {
    productCategories,
    virtual_currency_name };

}

function mapDispatchToProps(dispatch) {
  return {
    createSalesProductsActions: bindActionCreators(
    salesProductsActions.create,
    dispatch),

    updateSalesProductsActions: bindActionCreators(
    salesProductsActions.update,
    dispatch),

    successAction: bindActionCreators(successState, dispatch) };

}

const validate = values => {
  const errors = {};

  if (valid.required(values.product_category_id)) {
    errors.product_category_id = '请选择商品分类';
  }

  if (valid.required(values.title)) {
    errors.title = '请选择商品名称';
  }

  if (valid.required(values.unit_price)) {
    errors.unit_price = '请选择商品售价';
  }

  if (valid.integer(values.number)) {
    errors.number = '请输入整数';
  }

  if (values.number < 0) {
    errors.number = '库存数量不能小于0';
  }

  if (values.number > 1000000000) {
    errors.number = '库存数量不能大于10亿';
  }

  if (valid.required(values.number)) {
    errors.number = '请输入库存数量';
  }

  return errors;
};

const LEGACY_FORM_FIELDS = [
  "product_category_id",
  "title",
  "description",
  "cost",
  "unit_price",
  "point",
  "sku",
  "barcode",
  "images",
  "number",
  "status"
];

const formConfig = {
  form: 'SalesProductsForm',

  validate: validate,
  touchOnBlur: false };


SalesProductsForm = connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('SalesProductsForm', LEGACY_FORM_FIELDS)(SalesProductsForm)));

export default SalesProductsForm;
